// @ts-nocheck
import * as addPanel from '@/oldAddPanel';

export default {
  getCategorySections() {
    return addPanel.sections.getSections().repeater;
  },
};
